// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__T0psY","logo":"Footer_logo__+JiYo","text":"Footer_text__27sON","inner":"Footer_inner__CVEiR"};